class TradeInItemCount extends HTMLElement {
  constructor() {
    super();
  }

  renderNumberCartItems(totalItems) {
    const numberItemsNode = this.querySelector(".cart-number-items__number");
    numberItemsNode.innerHTML = totalItems;
    const itemSuffix = this.querySelector(".cart-number-items__item");
    const itemsSuffix = this.querySelector(".cart-number-items__items");
    this.classList.remove("hidden");
    if (totalItems === 0) {
      this.classList.add("hidden");
      itemSuffix.classList.add("hidden");
      itemsSuffix.classList.add("hidden");
    } else if (totalItems === 1) {
      this.classList.remove("hidden");
      itemSuffix.classList.remove("hidden");
      itemsSuffix.classList.add("hidden");
    } else {
      this.classList.remove("hidden");
      const itemsSuffix = this.querySelector(".cart-number-items__items");
      const itemSuffix = this.querySelector(".cart-number-items__item");
      itemsSuffix.classList.remove("hidden");
      itemSuffix.classList.add("hidden");
    }
  }
}
customElements.define("trade-in-cart-item-count", TradeInItemCount);
